/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */
/**
 * @description
 * Enum of workshop company affiliate flagged with `isAffiliate`
 */
export enum CompanyAffiliateEnum {
  AFFILIATE = "AFFILIATE",
  NON_AFFILIATE = "NON_AFFILIATE",
  UNKNOWN = "UNKNOWN"
}
